module.exports = __webpack_public_path__ + "media/images/social/yt-4e7fd0e5cc93d5977e4399bd18ebecbb.svg";